import React from 'react';

import { cssMap } from '@compiled/react';

import { SmartCardProvider } from '@atlaskit/link-provider';
import { Box, Stack } from '@atlaskit/primitives/compiled';

import { parseLuminaTagsToJSON } from './parser/tag-parser';
import { LuminaSection } from './section/lumina-section';
import { LuminaSubAgentContext } from './sub-agents/lumina-sub-agents-context';
import type { LuminaSubAgentResponseType } from './sub-agents/types';
import { getFirstFoldableSectionIdx } from './utils';

interface LuminaLayoutProps {
	isStreaming?: boolean;
	luminaSubAgentResponse?: LuminaSubAgentResponseType[];
	luminaTagResponse: string;
}

const styles = cssMap({
	containerStyles: {
		textAlign: 'left',
	},
});

export const LuminaLayout = ({
	luminaTagResponse,
	luminaSubAgentResponse,
	isStreaming = false,
}: LuminaLayoutProps): React.JSX.Element => {
	const parsedAnswer = parseLuminaTagsToJSON(luminaTagResponse);

	const firstFoldableIndex = getFirstFoldableSectionIdx(parsedAnswer);

	return (
		<SmartCardProvider>
			<LuminaSubAgentContext.Provider
				value={{ luminaSubAgentResponse: luminaSubAgentResponse || [] }}
			>
				<Box xcss={styles.containerStyles} testId="dynamic-layout-container">
					<Stack>
						{parsedAnswer &&
							parsedAnswer.length &&
							parsedAnswer.map((section, index) => {
								const isFoldable = section.attributes?.hasOwnProperty('folded');
								const defaultFoldedState = isFoldable
									? index === firstFoldableIndex
										? 'expanded'
										: 'collapsed'
									: undefined;

								return (
									<LuminaSection
										key={index}
										section={section}
										defaultFoldedState={defaultFoldedState}
										isStreaming={isStreaming}
									/>
								);
							})}
					</Stack>
				</Box>
			</LuminaSubAgentContext.Provider>
		</SmartCardProvider>
	);
};
